import { render, staticRenderFns } from "./AIReportAG.vue?vue&type=template&id=637131dd&scoped=true"
import script from "./AIReportAG.vue?vue&type=script&lang=js"
export * from "./AIReportAG.vue?vue&type=script&lang=js"
import style0 from "./AIReportAG.vue?vue&type=style&index=0&id=637131dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637131dd",
  null
  
)

export default component.exports